// extracted by mini-css-extract-plugin
module.exports = {"message":"OutOfStockProductWarnings_message__oeMq1"};